/**
 * Styled Components - Created by david on 28/06/18.
 */
import styled from 'styled-components'
import AntdInput from 'antd/lib/input'
import {
  GRAY_LIGHT,
  BLUE,
  WHITE,
  GRAY,
  TRANSPARENT,
} from '../../../theme/colors'

export const Container = styled.div`
  height: 100%;
  .category-group {
    width: 100%;
    margin-bottom: 6px;
    border: 1px solid #ccc;
    border-radius: 4px;
    overflow: hidden;
  }
  .category-header {
    padding: 6px 15px;
    background-color: #f7f7f7;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    &:hover {
      background-color: #eee;
    }
    h2 {
      margin-bottom: 0px;
      font-size: 16px;
    }
  }
  .category-content {
    padding: 15px;
    display: none;
    flex-wrap: wrap;
    opacity: 1;
    transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
  }
`

export const Header = styled.div`
  padding: 6px 30px;
  display: flex;
  flex-direction: column;
  row-gap: 6px;
  justify-content: space-between;
  min-height: 55px;
`

export const ArrowIcon = styled.img`
  padding-right: 8px;
`

export const Input = styled(AntdInput)`
  border-radius: 0px;
  height: 32px;
`

export const InputWrapper = styled.div`
  border-bottom: 1px solid ${GRAY_LIGHT};
  padding: 12px 32px;

  .ant-input-group-addon  {
    border: 0px;
    background: #131112;
  }

  .ant-input:hover {
    border-color: ${BLUE};
  }

  .ant-input:focus {
    border-color: ${BLUE};
    -webkit-box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
    outline: 0;
  }

  @media (min-width: 768px) and (max-width: 991px) {
    padding: 12px 10px;
  }
`

export const Button = styled.div`
  color: ${WHITE};
  cursor: pointer;
  font-size: 14px;
  line-height: 19px;
  user-select: none;
`

export const List = styled.div`
  height: calc(100vh - 256px);
  overflow: auto;
  padding: 4px 16px 32px 32px;
  @media (min-width: 768px) and (max-width: 991px) {
    padding: 4px 5px 32px 2px;
  }
`

export const RowList = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-left: 0;
  width: 100%;
`

export const Col = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  list-style: none;
  margin-bottom: 6px;
  text-align: center;
  width: calc(100% / 4);
`

type ColProps = {
  selected: boolean
}

export const Icon = styled.img`
  border: 1px solid
    ${({ selected }: ColProps) => (selected ? GRAY : TRANSPARENT)};
  cursor: pointer;
  height: 48px;
  width: 48px;
`

export const NotFound = styled.div`
  margin-top: 40px;
  text-align: center;
  width: 100%;
`

export const Loading = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  text-align: center;
  width: 100%;
`

export const LockContainer = styled.div`
  cursor: pointer;
  padding: 2px;
  display: inline-block;
  font-size: 20px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/SymbolTab/styledComponents.tsx